
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_lm6vo_1le9g_97",
  "layout-wrapper": "awsui_layout-wrapper_lm6vo_1le9g_98",
  "root-no-scroll": "awsui_root-no-scroll_lm6vo_1le9g_104",
  "layout": "awsui_layout_lm6vo_1le9g_98",
  "layout-no-scroll": "awsui_layout-no-scroll_lm6vo_1le9g_115",
  "layout-main": "awsui_layout-main_lm6vo_1le9g_119",
  "layout-main-scrollable": "awsui_layout-main-scrollable_lm6vo_1le9g_125",
  "unfocusable": "awsui_unfocusable_lm6vo_1le9g_130",
  "navigation-panel": "awsui_navigation-panel_lm6vo_1le9g_134",
  "drawer": "awsui_drawer_lm6vo_1le9g_138",
  "drawer-mobile": "awsui_drawer-mobile_lm6vo_1le9g_144",
  "drawer-closed": "awsui_drawer-closed_lm6vo_1le9g_147",
  "drawer-content": "awsui_drawer-content_lm6vo_1le9g_155",
  "toggle": "awsui_toggle_lm6vo_1le9g_177",
  "visual-refresh-toggle": "awsui_visual-refresh-toggle_lm6vo_1le9g_182",
  "visual-refresh-toggle-type-tools": "awsui_visual-refresh-toggle-type-tools_lm6vo_1le9g_186",
  "visual-refresh-toggle-type-navigation": "awsui_visual-refresh-toggle-type-navigation_lm6vo_1le9g_189",
  "breadcrumbs-desktop": "awsui_breadcrumbs-desktop_lm6vo_1le9g_199",
  "content-header-wrapper": "awsui_content-header-wrapper_lm6vo_1le9g_204",
  "content-wrapper": "awsui_content-wrapper_lm6vo_1le9g_208",
  "content-overlapped": "awsui_content-overlapped_lm6vo_1le9g_212",
  "content-extra-top-padding": "awsui_content-extra-top-padding_lm6vo_1le9g_216",
  "panel-wrapper-outer": "awsui_panel-wrapper-outer_lm6vo_1le9g_220",
  "mobile": "awsui_mobile_lm6vo_1le9g_226",
  "open": "awsui_open_lm6vo_1le9g_232",
  "panel-wrapper-inner": "awsui_panel-wrapper-inner_lm6vo_1le9g_238"
};
  